import React from "react";
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/Gotham-Book-a513.otf';
import './fonts/Gotham-Bold.otf';
import './fonts/Gotham-Book.otf';
import './fonts/Gotham-BookItalic.otf';
import './fonts/Gotham-Light.otf';
import './fonts/Gotham-Medium.otf';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
